import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['pricing', 'discounts'];

export function useDiscounts() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/pricing/discounts');
      return data?.discounts || data?.data || data || [];
    },
    staleTime: 30_000
  });
}

export function useCreateDiscount() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/pricing/discounts', body).then((r) => r.data),
    successMessage: 'تم إنشاء الخصم',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useUpdateDiscount() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/pricing/discounts/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ الخصم',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeleteDiscount() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/pricing/discounts/${id}`).then((r) => r.data),
    successMessage: 'تم حذف الخصم',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
